export default __webpack_public_path__ + "static/media/proceed-to-gas.6a467647.svg";